import { useQuery } from "@tanstack/react-query"

import { Resource, Scope } from "@/constants/permission"
import { CARRIER_QUERY_KEY, CARRIER_LIST_QUERY_KEY } from "@/constants/query"
import { getCarrierById, getCarriers, getCarriersSelectList } from "@/http/carrier"

import { usePermission } from "../usePermission"

import { IRequestParams } from "@/types/api"



export const useCarrierQuery = (params?: IRequestParams) => {
  return useQuery({
      queryFn: () => getCarriers(params || {}),
      queryKey: [CARRIER_QUERY_KEY, params],
      retry: false
    })
}

export const useCarrierSelectListQuery = () => {
    const { hasPermission } = usePermission()

    return useQuery({
        queryFn: () => getCarriersSelectList(),
        queryKey: [CARRIER_LIST_QUERY_KEY],
        retry: false,
        enabled : hasPermission(Resource.Carrier, Scope.Read)
    })
}

export const useCarrierByIdQuery = (id: number)  => {
    return useQuery({
        queryFn: () => getCarrierById(id),
        queryKey: [CARRIER_QUERY_KEY, id],
        enabled: id !== 0
    })
}
